import Fetch from './index'
import { BASE_URL } from '../libs/config'
import * as tool from '../libs/tool'
const appId = tool.getAppId() || null
const axios = new Fetch(BASE_URL, appId)

export function getAppInfoByAppId () {
  // 根据appId获取app详情
  return axios.request('get', `/app/detailByAppId/${appId}`)
}

export function getAppInfoBySite (site) {
  // 根据网址获取app信息
  return axios.request('get', `/app/detailBySite/${site}`)
}

export function getAppList (params) {
  // 获取项目列表
  return axios.request('get', `/app/projects/${params.appId}`, params)
}

export function getChildren ({ id, m }) {
  // 获取子项目
  return axios.request('get', `/app/children/${id}`, m)
}

export function getCount () {
  // 获取已出具的法律意见书数量
  return axios.request('get', `/question/getCount/${appId}`)
}



// WEBPACK FOOTER //
// ./src/api/app.js